import { Space } from 'antd';
import { snakeCase, startCase } from 'lodash';
import React, { FC } from 'react';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'components/organisms/tasks/filters/text';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { removeTrailingDots } from './utils';

export const TextFilterToText: FC<{ filter: TextFieldFilter }> = ({
  filter,
}) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <Space size={4}>
      <span>{startCase(fieldLabel)}</span>
      <span>
        {removeTrailingDots(
          useTranslation(
            `task_list.filters.${snakeCase(type)}` as TranslationKey,
          ),
        )}
      </span>
      {filter.type === TextFieldFilterOperationType.Contains ||
      filter.type === TextFieldFilterOperationType.DoesNotContain ? (
        <span>{filter.value}</span>
      ) : null}
    </Space>
  );
};
